var React = require('react');

function Viewed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.25.106C4.5.106 1.298 2.438 0 5.73c1.298 3.292 4.5 5.625 8.25 5.625s6.953-2.333 8.25-5.625C15.203 2.438 12 .106 8.25.106zm0 9.375a3.751 3.751 0 0 1 0-7.501c2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75zm0-6A2.247 2.247 0 0 0 6 5.73a2.247 2.247 0 0 0 2.25 2.25 2.247 2.247 0 0 0 2.25-2.25 2.247 2.247 0 0 0-2.25-2.25z","fill":"currentColor","fillRule":"evenodd"}));
}

Viewed.defaultProps = {"width":"17","height":"12","viewBox":"0 0 17 12"};

module.exports = Viewed;

Viewed.default = Viewed;
